const url = '/productTypes';
const Provider = 'ProductTypes';
const dbModel = 'ProductTypes';

export { url, Provider, dbModel };
